type isVerified = boolean;

interface PostalAddress {
  regionCode: string;
  languageCode: string;
  postalCode: string;
  administrativeArea: string;
  locality: string;
  addressLines: string[];
}

interface VerifyAddressResponse {
  isVerified: boolean;
  formattedAddress?: string;
  postalAddress?: PostalAddress;
  coordinates?: { lat: number; long: number };
}

const isAddressVerified = (data: any) => {
  return !!data.verdict.addressComplete;
};

const extractFormattedAddress = (data: any) => {
  if (data.address) {
    return data.address.formattedAddress;
  }
  return null;
};
const extractPostalAddress = (data: any) => {
  if (data.address) {
    return data.address.postalAddress;
  }
  return null;
};

const extractGeoLocaiton = (data: any) => {
  return {
    lat: data?.geocode?.location.latitude || 0,
    long: data?.geocode?.location.longitude || 0,
  };
};

type AgrantisAddress = {
  familyName: string;
  givenName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  addressPostcode: string;
  addressLocality: string;
};

export const verifyAddress = async (
  data: AgrantisAddress | string,
  apiKey: string,
): Promise<VerifyAddressResponse> => {
  const payload =
    typeof data === 'string'
      ? {
          address: {
            regionCode: 'DE',
            addressLines: [data],
          },
        }
      : {
          address: {
            regionCode: 'DE',
            locality: data.addressLocality,
            postalCode: data.addressPostcode,
            addressLines: [data.addressLine1, data.addressLine2],
          },
        };

  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    };
    const url = `https://addressvalidation.googleapis.com/v1:validateAddress?key=${apiKey}`;
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    const geocodingResponse = data.result;
    //
    const isVerified: isVerified = isAddressVerified(geocodingResponse);
    const postalAddress = isVerified
      ? extractPostalAddress(geocodingResponse)
      : null;
    const formattedAddress = isVerified
      ? extractFormattedAddress(geocodingResponse)
      : null;

    const coordinates = extractGeoLocaiton(geocodingResponse);

    return { isVerified, formattedAddress, postalAddress, coordinates };
  } catch (error) {
    console.log(error);
    return { isVerified: false };
  }
};
